import store from "@/store"

export default (dtbls) => {

  if (!dtbls)
    dtbls = getAllDataTablesIds()

  let reloadDataTables = store.state.pages.reloadDataTables.slice()

  dtbls.forEach((el) => {    
    const id = el + "-dtbl"
    if (reloadDataTables.indexOf(id) == -1)
      reloadDataTables.push(id)
  })

  store.commit("pages/setReloadDataTables", reloadDataTables)
}

function getAllDataTablesIds() {

  let ids = []
  const dataTables = store.state.pages.dataTables

  for (let prop in dataTables) {
    if (dataTables.hasOwnProperty(prop)) {
      ids.push(prop.replace("-dtbl", ""))
    }
  }

  return ids
}